import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    card: {
      width: 400,
      height: 'auto',
      backgroundColor: '#225785',
      borderRadius: "10px",
      display: 'flex', 
      justifyContent: 'center',
      flexDirection: 'row',
      color: '#cccccc',
      margin: 'auto',
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    strip: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginTop: '5px',
    },
  }));

const NoRecords = () => {
    const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h5" component="div" align="center">
          No Records Found
        </Typography>
      </CardContent>
    </Card>
  );
};

export default NoRecords;
